import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import notify from 'devextreme/ui/notify';
import { APP_SETTINGS } from '../settings';
// import { environment } from '@environments/environment';

declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json');

@Injectable({
    providedIn: 'root'
})
export class AppInformationService {
    config: any;
    appVersion: string;
    applicationInfo: any;
    isLoggedIn = false;
    title: string;
    hideNav = false;
    pleaseWait = false;
    versionWarning;
    clientVersion;
    serviceVersion;

    private initVersionCheckEvent = new Event('initVersionCheck');

    constructor() {
        this.appVersion = appVersion;
        this.clientVersion = appVersion;

        document.addEventListener('setAppInfoServiceVersion', (args: any) => {
            if (args && args.detail && args.detail.serviceVersion) {
                this.serviceVersion = args.detail.serviceVersion;
                document.dispatchEvent(this.initVersionCheckEvent);
            }
        });
    }

    get settings() {
        return APP_SETTINGS;
    }

    async pleaseWaitShow() {
        await Promise.resolve(null);
        this.pleaseWait = true;
    }

    async pleaseWaitHide() {
        await Promise.resolve(null);
        this.pleaseWait = false;
    }

    notifyToast(message: string, type: 'info' | 'warning' | 'error' | 'success' = 'success', displayTime = 5000) {
        notify({
            position: {
                my: 'center top',
                at: 'center top',
                offset: '0 90',
                of: 'body'
            },
            // position: { my: 'center top', at: 'right bottom', offset: '0 0', of: '.page-main' },
            message,
            closeOnClick: true,
            displayTime,
            width: '300px',
            type
        });
    }
}
